'use es6';

import { isEmpty } from 'underscore';
import buildLegalConsent from 'forms-utils-lib/legalConsent/buildLegalConsent';
import { LEGAL_CONSENT_OPTIONS_KEY } from 'FormsCommonComponents/constants/LegalConsent';
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import getSubscriptionsForLegalConsent from 'FormsUI/selectors/legalConsent/getSubscriptionsForLegalConsent';
import { getLegalConsentOptions } from 'FormsUI/selectors/LegalConsent';
import { updateMetaData } from 'FormsUI/actions/FormDefinition';
const updateLegalConsentOptionFromApi = (legalConsentOption, legalConsentCopy) => (dispatch, getState) => {
  const state = getState();
  const currentLegalConsent = getLegalConsentOptions(state);
  const subscriptionDefinitions = getSubscriptionsForLegalConsent(state);
  const updatedLegalConsent = new LegalConsent(buildLegalConsent({
    legalConsentOption,
    legalConsentCopy,
    currentLegalConsent,
    subscriptionDefinitions
  }));
  if (isEmpty(currentLegalConsent)) {
    return dispatch(updateMetaData(LEGAL_CONSENT_OPTIONS_KEY, updatedLegalConsent));
  }
  return dispatch(updateMetaData(LEGAL_CONSENT_OPTIONS_KEY, updatedLegalConsent.merge(currentLegalConsent)));
};
export default updateLegalConsentOptionFromApi;